module.exports = __webpack_public_path__ + "img/yishi12.369d5eb2.jpg";